import React, { useContext } from 'react';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import styles from './MovieModal.module.scss';

type Props = {
  youtubeId?: string;
};

const MovieModal: React.FC<Props> = ({ youtubeId }) => {
  const setModal = useContext(ModalDispatchContext);
  const closeModal = () => {
    setModal(null);
  };

  return youtubeId ? (
    <div className={styles.content}>
      <div className={styles.close}>
        <FontAwesomeIcon className={styles.close__icon} icon={faTimes} onClick={closeModal} />
      </div>
      <iframe
        className={styles.iframe}
        src={`https://www.youtube.com/embed/${youtubeId}`}
        title='YouTube video player'
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      />
    </div>
  ) : null;
};

MovieModal.defaultProps = {
  youtubeId: undefined,
};

export default MovieModal;
